import { format } from 'date-fns';

export const DATE_FORMAT = 'MMM d, yyyy';
export const DATE_TIME_FORMAT = 'MMM d, yyyy h:mm a';

type DateInput = Date | string | number | null | undefined;

const toDate = (input: DateInput): Date | null => {
  if (input == null || input === '') return null;
  const date = input instanceof Date ? input : new Date(input);
  return isNaN(date.getTime()) ? null : date;
};

export const formatDate = (input: DateInput): string => {
  const date = toDate(input);
  return date ? format(date, DATE_FORMAT) : '';
};

export const formatDateTime = (input: DateInput): string => {
  const date = toDate(input);
  return date ? format(date, DATE_TIME_FORMAT) : '';
};
